/*!
 * Grow Day countdown — The Grow Guys
 * TGG Theme Dev v1.0, adapted from the Claude Design handoff for Impulse 7.6.2 (Oct 2026).
 * Plain JavaScript, no dependencies, nothing stored per visitor. Every visitor counts down to
 * the same fixed moment, so a refresh or a return visit can never restart it.
 *
 * Loading: snippets/grow-day-head.liquid sets <html data-gd-end> and the first data-grow-day
 * phase inline, before first paint, then loads this file with defer. The end moment itself
 * lives only in snippets/grow-day-end.liquid; this file has no end date of its own.
 *
 * Markup hooks
 *   [data-gd-sale]   every sale element. Hidden at zero.
 *   [data-gd-after]  shown only after zero
 *   [data-gd-timer]  one countdown. Slots inside: [data-gd-d] [data-gd-h] [data-gd-m] [data-gd-s]
 *                    [data-gd-days] wraps the days unit; hidden unless more than 24 hours remain
 *                    [data-gd-dl] receives "Day" or "Days"
 *   [data-gd-ends]   receives e.g. "Ends 11:59pm Sunday in TAS (AEDT)"
 *   [data-gd-date]   receives e.g. "Sunday 11 Oct" in the visitor's own timezone
 *   <html data-grow-day="live | final | ended">  final = under 3 hours (Ember), ended = hide everything
 * Server-rendered text stays in place when a device can't report its timezone.
 */
(function (w, d) {
  'use strict';
  var html = d.documentElement;
  var END = Date.parse(html.getAttribute('data-gd-end') || '');
  if (isNaN(END)) return;
  var FINAL_MS = 3 * 60 * 60 * 1000;

  var REGIONS = {
    'Australia/Hobart': 'TAS', 'Australia/Tasmania': 'TAS', 'Australia/Currie': 'TAS', 'Antarctica/Macquarie': 'TAS',
    'Australia/Melbourne': 'VIC', 'Australia/Victoria': 'VIC',
    'Australia/Sydney': 'NSW/ACT', 'Australia/NSW': 'NSW/ACT', 'Australia/ACT': 'NSW/ACT', 'Australia/Canberra': 'NSW/ACT',
    'Australia/Broken_Hill': 'Broken Hill', 'Australia/Yancowinna': 'Broken Hill',
    'Australia/Lord_Howe': 'Lord Howe Island', 'Australia/LHI': 'Lord Howe Island',
    'Australia/Adelaide': 'SA', 'Australia/South': 'SA',
    'Australia/Brisbane': 'QLD', 'Australia/Queensland': 'QLD', 'Australia/Lindeman': 'QLD',
    'Australia/Darwin': 'NT', 'Australia/North': 'NT',
    'Australia/Perth': 'WA', 'Australia/West': 'WA',
    'Australia/Eucla': 'Eucla'
  };

  function compute(now) {
    var ms = END - now;
    if (!(ms > 0)) return { phase: 'ended', ms: 0, showDays: false, d: 0, h: 0, m: 0, s: 0 };
    var t = Math.ceil(ms / 1000), showDays = t > 86400;
    return {
      phase: ms < FINAL_MS ? 'final' : 'live', ms: ms, showDays: showDays,
      d: Math.floor(t / 86400),
      h: showDays ? Math.floor(t % 86400 / 3600) : Math.floor(t / 3600),
      m: Math.floor(t % 3600 / 60),
      s: t % 60
    };
  }

  function zone() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
  }

  function parts(locale, opts) {
    var out = {};
    new Intl.DateTimeFormat(locale, opts).formatToParts(new Date(END)).forEach(function (p) { out[p.type] = p.value; });
    return out;
  }

  var cache = {};
  function endLabel(tz) {
    tz = tz || zone();
    if (!tz) return null;
    if (Object.prototype.hasOwnProperty.call(cache, tz)) return cache[tz];
    var out = null;
    try {
      var region = REGIONS[tz] || '';
      var p = parts('en-AU', { timeZone: tz, weekday: 'long', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true });
      // Australian abbreviations from en-AU (AEDT, ACDT...); elsewhere the visitor's own locale (NZDT, BST, PDT...)
      var abbr = parts(region ? 'en-AU' : undefined, { timeZone: tz, timeZoneName: 'short' }).timeZoneName || '';
      var time = p.hour + ':' + p.minute + String(p.dayPeriod || '').toLowerCase().replace(/[^a-z]/g, '') + ' ' + p.weekday;
      out = {
        text: 'Ends ' + time + (region ? ' in ' + region : ' your time') + (abbr ? ' (' + abbr + ')' : ''),
        time: time, region: region, abbr: abbr, local: !region, zone: tz,
        date: p.weekday + ' ' + p.day + ' ' + p.month
      };
    } catch (e) { out = null; }
    return (cache[tz] = out);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function each(sel, fn, scope) { var n = (scope || d).querySelectorAll(sel); for (var i = 0; i < n.length; i++) fn(n[i]); }
  function setText(el, v) { v = String(v); if (el.textContent !== v) el.textContent = v; }

  function paint() {
    var st = compute(Date.now());
    if (html.getAttribute('data-grow-day') !== st.phase) html.setAttribute('data-grow-day', st.phase);
    if (st.phase === 'ended') {
      each('[data-gd-sale]', function (el) { el.hidden = true; });
      each('[data-gd-after]', function (el) { el.hidden = false; });
      return false;
    }
    each('[data-gd-timer]', function (t) {
      each('[data-gd-d]', function (el) { setText(el, pad(st.d)); }, t);
      each('[data-gd-h]', function (el) { setText(el, pad(st.h)); }, t);
      each('[data-gd-m]', function (el) { setText(el, pad(st.m)); }, t);
      each('[data-gd-s]', function (el) { setText(el, pad(st.s)); }, t);
      each('[data-gd-dl]', function (el) { setText(el, st.d === 1 ? 'Day' : 'Days'); }, t);
      each('[data-gd-days]', function (el) { el.hidden = !st.showDays; }, t);
    });
    var lab = endLabel();
    if (lab) {
      each('[data-gd-ends]', function (el) { setText(el, lab.text); });
      each('[data-gd-date]', function (el) { setText(el, lab.date); });
    }
    return true;
  }

  var timer;
  function loop() {
    clearTimeout(timer);
    if (paint()) timer = setTimeout(loop, 1000 - (Date.now() % 1000) + 15);
  }

  html.setAttribute('data-grow-day', compute(Date.now()).phase);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', loop); else loop();
  d.addEventListener('visibilitychange', function () { if (!d.hidden) loop(); });
  w.addEventListener('pageshow', loop); // back/forward cache restores a frozen page
  d.addEventListener('shopify:section:load', loop); // theme editor re-renders sections without a reload

  w.GrowDay = { END: END, FINAL_MS: FINAL_MS, compute: compute, endLabel: endLabel, zone: zone, refresh: loop };
})(window, document);